<template>
  <section
    class="livecourse-detail-container wrapper"
    :class="{'livecourse-detail-container_mobile': isMobile}"
    :style="mode === 'buying' ? 'padding-bottom: 144px;' : ''">
    <div class="livecourse-detail-header" ref="livecourse-detail-header">
      <ct-progressBar style="transform: translateY(-12px);" :total="progress.total" :current="progress.current"></ct-progressBar>
      <div class="livecourse-detail-header-infobox">
        <div class="livecourse-detail-header-left" v-if="!isMobile">
          <!-- <span
            class="livecourse-detail-status-tip"
            :class="{
              'half': courseData.live_broadcast_state === 1,
              'notstart': courseData.live_broadcast_state === 2,
              'total': courseData.live_broadcast_state > 2
            }">
              {{ courseStatus[courseData.live_broadcast_state] }}
            </span> -->
          <img :src="courseData.cover" alt="">
        </div>
        <div class="livecourse-detail-header-right">
          <h2 class="livecourse-detail-title">{{ courseData.title }}</h2>
          <p class="livecourse-detail-desp">{{ courseData.short_desp }}</p>
          <div class="livecourse-detail-time">
            <span class="livecourse-detail-time-tips">{{ $t('course.LiveTime') }}</span>
            {{ begin_at_format }} - {{ end_at_format }}
            <span class="livecourse-detail-time-spin">
              {{ courseData.chapter ? courseData.chapter.length > 1 ? courseData.chapter.length : courseData.chapter.length : '0' }} {{ courseData.chapter && courseData.chapter.length > 1 ? $t('course.Lessons') : $t('course.Lesson') }}
            </span>
          </div>
          <div class="livecourse-detail-price">
            <!-- ${{  Number((courseData.price/100).toFixed(2)) }}
            <span class="livecourse-detail-virtual-price" v-if="courseData.virtual_price">${{ Number((courseData.virtual_price/100).toFixed(2)) }}</span> -->
          </div>
          <ct-button v-if="courseData.join_status === -1" size="medium" @click="joinCourse" type="primary">{{ $t('course.JoinCourse') }}</ct-button>
          <span v-else class="join-status">{{ $t('course.HasApply') }}</span>

          <!-- <div class="livecourse-detail-opration">
            <ct-button v-if="courseData.price !== 0" size="medium" @click="buy(false)" type="primary">Buy Now</ct-button>
            <ct-button v-else :isLoading="addFreeCouseLoading" size="medium" @click="addFreeCourse" type="primary">Add to My Course</ct-button>
            <span v-if="courseData.price !== 0" class="livecourse-detail-refund-tips">Refund Deadline: {{last_refund_time_format}}</span>
          </div> -->
          <div class="livecourse-detail-freetrial" v-if="courseData.trial_course">
            <div class="freetrial-tips">
              Experience a similar course before pay for it.
              <span class="line"></span>
            </div>
            <div class="freetrial-box">
              <div class="freetrial-content">
                <h3>{{ courseData.trial_course.course_title }}</h3>
                <p><ct-icon multi-color name="huatong"></ct-icon> {{ courseData.trial_course.teachers }}</p>
              </div>
              <ct-button @click="goReplay(courseData.trial_course.goods_id, courseData.trial_course.course_id)" type="secondary">Have a try <ct-icon style="width: 16px;height: 16px;" name="play" multi-color></ct-icon> </ct-button>
            </div>
          </div>
        </div>
      </div>
      <div class="livecourse-detail-header-navtab" :class="isFixed ? 'fixed-bar' : ''">
        <div :class="isFixed ? 'wrapper' : ''">
          <div class="fixbar-buy-box" v-show="isFixed">
            <!-- <span class="price">${{ Number((courseData.price/100).toFixed(2)) }}</span>
            <span class="virtual-price" v-if="courseData.virtual_price">${{ Number((courseData.virtual_price/100).toFixed(2)) }}</span>
            <ct-button type="primary" v-if="courseData.price !== 0" size="medium" @click="buy(false)">Buy Now</ct-button>
            <ct-button type="primary" :isLoading="addFreeCouseLoading" v-else size="medium" @click="addFreeCourse">Add to My Course</ct-button> -->
          </div>
          <ul class="livecourse-detail-header-navtab-list">
            <li v-for="item in tabs" :key="item.tab">
              <span @click="changeTab(item)" :class="item.active ? 'active' : ''">
                <ct-icon :name="item.icon"></ct-icon>
                {{ $t(item.tab) }}
                <span class="underline"></span>
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="livecourse-detail-body">
      <div class="livecourse-detail-tab-content">
        <div v-show="tabs[0].active" class="livecourse-detail-richtext-content" v-html="courseData.desp" >
        </div>
        <div v-show="tabs[1].active">
          <ul class="livecourse-detail-subcourse-box" >
            <li
              v-for="(item, index) in courseData.chapter"
              :key="item.chapter_id"
              :class="item.chooseStatusClass">
              <h2 class="livecourse-detail-subcourse-head">
                <span class="livecourse-detail-subcourse-head-title">{{ item.chapter_title }}</span>
<!--                <span-->
<!--                  class="livecourse-detail-subcourse-head-status"-->
<!--                  :class="item.chapter_live_broadcast_state === 1 ? 'half' : item.chapter_live_broadcast_state === 2 ? 'notstart' : 'total'">-->
<!--                  {{ chapterStatus[item.chapter_live_broadcast_state] }}-->
<!--                </span>-->
                <!-- <span v-if="item.chapter_price" class="livecourse-detail-subcourse-head-price">${{ Number((item.chapter_price/100).toFixed(2)) }}</span> -->
              </h2>
              <p class="livecourse-detail-subcourse-body" v-if="!isMobile">
                <ct-icon style="width: 31px;height: 18px;margin-right: 8px;" name="live_hui" multi-color></ct-icon>
                <span>{{ getChapterTime(item) }}</span>
                <ct-icon style="margin: 0 8px 0 32px;" multi-color name="huatong"></ct-icon>
                <span>By {{ item.chapter_teacher }}</span>
              </p>
              <div class="livecourse-detail-subcourse-body" v-else>
                <div>
                    <ct-icon style="width: 31px;height: 18px;margin-right: 8px;" name="live_hui" multi-color></ct-icon>
                    <span>{{ getChapterTime(item) }}</span>
                </div>
                <div>
                    <ct-icon style="margin: 0 8px 0 32px;" multi-color name="huatong"></ct-icon>
                    <span>By {{ item.chapter_teacher }}</span>
                </div>

              </div>
              <div style="marginTop: 8px;">
                <ct-button
                    v-for="workItem in item.work_list"
                    :key="workItem.work_id"
                    type="primary"
                    size="mini"
                    class="test-btn"
                    style="marginRight: 8px;"
                    @click="jumpAnswer(workItem, bigCourseId, item,)"
                    >{{ workItem.work_type | workTypeLabel($t) }}</ct-button>
              </div>
              <template v-if="isAdminRole || item.chapter_price === 0">
                <!-- <span
                  v-if="item.is_overdue"
                  size="mini"
                  style="color:rgba(26,61,94,.3);line-height: 32px;cursor:not-allowed;font-size: 14px;"
                  class="join-class-btn">Expired</span>
                <ct-button
                  v-else-if="item.chapter_live_broadcast_state === 1 || item.chapter_live_broadcast_state === 2"
                  class="join-class-btn"
                  type="primary"
                  size="mini"
                  style="width: 120px;"
                  @click="goLive(bigCourseId, item.chapter_id)"
                  :disabled="item.chapter_live_broadcast_state === 2">Join the class</ct-button> -->
                <ct-button
                  v-if="item.chapter_live_broadcast_state === 3"
                  type="secondary"
                  size="mini"
                  style="width: 120px;"
                  @click="goReplay(bigCourseId, item.chapter_id)"
                  class="join-class-btn">{{ $t('course.Replay') }}</ct-button>
              </template>
              <span class="livecourse-detail-subcourse-tip">{{ index + 1 }}</span>
            </li>
          </ul>
        </div>
        <!-- <div v-show="tabs[2].active" class="livecourse-detail-refund-content">
          <img src="@/assets/img/comet/live/refund_text.png" alt="">
        </div> -->
        <!-- <div v-show="tabs[3].active" class="livecourse-pad-Faqbox">
          <h2>
            FAQS
            <span class="underline"></span>
          </h2>
          <div>
            <h4>
              <span>Q</span>
               How long is the period of validity of our purchased course?
            </h4>
            <p>
              The period of validity of your purchased course is 6 month. During this time, you can learn/watch the lessons in the course unlimited times.
            </p>
          </div>
          <div>
            <h4>
              <span>Q</span>
              How could I know when the period of validity the my purchased courses end?
            </h4>
            <p>
              Every course you bought has its own invalid time because the beginning time of the period of validity for each course is different. This information is displayed in the list of lessons of your purchased courses.
            </p>
          </div>
          <div>
            <h4>
              <span>Q</span>
              Could I extend the period of validity of my purchase course when it comes to the end?
            </h4>
            <p>
              Sorry, there is no way to extend the period of validity of your course. So, please learn the course in time.
            </p>
          </div>
        </div> -->
      </div>
      <!-- <div class="livecourse-detail-faqbox">
        <h2>
          FAQS
          <span class="underline"></span>
        </h2>
        <div>
          <h4>
            <span>Q</span>
              How long is the period of validity of our purchased course?
          </h4>
          <p>
            The period of validity of your purchased course is 6 month. During this time, you can learn/watch the lessons in the course unlimited times.
          </p>
        </div>
        <div>
          <h4>
            <span>Q</span>
            How could I know when the period of validity the my purchased courses end?
          </h4>
          <p>
            Every course you bought has its own invalid time because the beginning time of the period of validity for each course is different. This information is displayed in the list of lessons of your purchased courses.
          </p>
        </div>
        <div>
          <h4>
            <span>Q</span>
            Could I extend the period of validity of my purchase course when it comes to the end?
          </h4>
          <p>
            Sorry, there is no way to extend the period of validity of your course. So, please learn the course in time.
          </p>
        </div>
      </div> -->
    </div>
    <div v-show="mode === 'buying'" class="livecourse-detail-comfirmbar">
      <div class="wrapper confirm-box">
        <p class="confirm-box-tips">This course can be refunded entirely before <span class="confirm-refund-time">{{ last_refund_time_format }}</span>, after that, only the lessons in the state of "To be broadcast" can be refund. </p>
        <div class="confirm-box-price">
          Price:
          <span>${{ realPrice }}</span>
        </div>
        <ct-button class="confirm-box-confirmbtn" @click="buy(true)" type="primary" size="large">Comfirm</ct-button>
        <ct-button class="confirm-box-cancelbtn" @click="cancel" type="text_secondary_light">Cancel</ct-button>
      </div>
    </div>
  </section>
</template>

<script>
import api from '../../api'
import moment from 'moment'
import { mapGetters } from 'vuex'
import { vueAppPassportDomin } from '@ca/constants/variables'
import { courseStatus, chapterStatus } from '@ca/constants/index'
export default {
  name: 'LiveCourseDetail',
  data () {
    return {
      courseData: {},
      end_at_format: '',
      begin_at_format: '',
      last_refund_time_format: '',
      tabs: [
        {
          tab: 'course.CourseDetails',
          icon: 'CourseDetails',
          active: true
        },
        {
          tab: 'course.Syllabus',
          icon: 'Syllabus',
          active: false
        }
        // {
        //   tab: 'Refund Instructions',
        //   icon: 'RefundInstructions',
        //   active: false
        // },
        // {
        //   tab: 'FAQs',
        //   icon: 'sy-icon-feedback',
        //   active: false
        // }
      ],
      isFixed: false,
      mode: 'normal',
      courseStatus,
      realPrice: 0,
      hasBuyChapters: {},
      addFreeCouseLoading: false,
      chapterStatus,
      isMobile: window.innerWidth <= 768
    }
  },
  filters: {
    workTypeLabel (val, $t) {
      if (+val === 1) {
        return $t('course.WorkTypeEpParts')
      } else if (+val === 2) {
        return $t('course.WorkTypeExItems')
      } else if (+val === 3) {
        return $t('course.WorkTypeCmkItems')
      }
    },
    joinStatusLabel (val, $t) {
      if (val === 0) {
        return $t('course.HasApply')
      } else if (val === 1) {
        return $t('course.Approved')
      } else if (val === 2) {
        return $t('course.Reject')
      }
    }
  },
  methods: {
    joinCourse () {
      api.studentSignUp({
        data: {
          class_id: +this.bigCourseId
        }
      }).then(({ data }) => {
        if (data.code === 1) {
          this.$toast({
            message: this.$t('course.JoinCourseSuccess'),
            duration: 3000
          })
          this.courseData.join_status = 0
        } else {
          this.$toast(data.error)
        }
      })
    },
    jumpAnswer (workItem, bigId, row) {
      const courseStartTime = row.chapter_begin_at * 1000
      const currentDate = new Date().getTime()
      if (courseStartTime > currentDate && +workItem.work_type === 3) {
        this.$toast(this.$t('course.CourseNoStarted'))
      } else {
        api.getExamInfo({
          params: {
            work_id: +workItem.work_id,
            class_id: +bigId,
            subclass_id: +row.chapter_id
          }
        }).then(({ data }) => {
          if (data.code === 1) {
            this.$router.push({
              name: 'answer',
              params: {
                exam_id: workItem.work_id,
                class_id: bigId,
                subclass_id: row.chapter_id
              }
            })
          } else if (data.code === 100000) {
            // 跳转登录页面
            window.location.href = vueAppPassportDomin + '/login?return_url=' + window.location.href
          } else {
            this.$toast({
              type: 'error',
              message: data.error
            })
          }
        })
      }

    //   let input = document.createElement('input')
    //   input.value = `${process.env.VUE_APP_DOMIN}/answer/${workId}/${bigId}/${chapterId}`
    //   document.body.appendChild(input)
    //   input.select()
    //   document.execCommand('copy')
    //   document.body.removeChild(input)
    //   this.$toast('Replicating Success')
    },
    goNotFound () {
      this.$confirm({
        message: this.$t('course.NoReadySelling'),
        confirmButtonText: this.$t('common.GotIt'),
        handleAction: () => {
          window.location.href = process.env.VUE_APP_DOMIN + '/live'
        },
        closed: () => {
          window.location.href = process.env.VUE_APP_DOMIN + '/live'
        }
      })
    },
    changeTab (item) {
      if (item.active) return
      this.tabs.forEach(el => {
        el.active = false
      })
      this.tabs.find(el => {
        return el.tab === item.tab
      }).active = true
    },
    formatData (data) {
      if (data) {
        let a = JSON.parse(JSON.stringify(data))
        this.end_at_format = moment(a.end_at * 1000).format('DD/MM/YYYY')
        this.begin_at_format = moment(a.begin_at * 1000).format('DD/MM/YYYY')
        this.last_refund_time_format = moment(a.last_refund_time * 1000).format('HH:mm MMM Do, YYYY')
        a.chapter.forEach((el, index) => {
          el.chooseStatusClass = 'normal'
        })
        a.cover = a.cover || this.defaultCover
        return a
      } else {
        return []
      }
    },
    getChapterTime (item) {
      const str = `${moment(item.chapter_begin_at * 1000).format('HH:mm')} - ${moment(item.chapter_end_at * 1000).format('HH:mm MMM Do, ddd')}`
      return str
    },
    buy (isConfirm) {
      // 未登录
      if (!this.isAuthenticated) {
        window.location.href = vueAppPassportDomin + '/login?return_url=' + window.location.href
        return
      }
      // 管理员
      if (this.isAdminRole) {
        this.$toast({ type: 'warning', message: '管理员账号，无需购买' })
        return
      }
      // 查询购买情况
      api.queryChapters({
        params: {
          goods_id: this.bigCourseId
        }
      }).then(res => {
        let data = res.data
        if (data.code === 1) {
          data = data.data
          if (data && data.length > 0) {
            data.forEach(el => {
              this.hasBuyChapters[el.subclass_id] = true
            })
          }
          this.continuePay(isConfirm)
        } else {
          this.$toast('Oops, something went wrong, please try again later')
        }
      })
    },
    continuePay (isConfirm) {
      let a = this.courseData.chapter.every(el => {
        if (el.chapter_price === 0) return true
        if (this.hasBuyChapters[el.chapter_id] === true) {
          return true
        } else {
          return false
        }
      })
      if (a) {
        this.$root.courseModalText = 'You\'ve bought this course. All your purchased courses are displayed here.'
        this.$root.courseModal = true
        return
      }
      // 有未支付订单
      api.querySameOrder({
        params: {
          goods_id: this.bigCourseId
        }
      }).then(res => {
        let data = res.data
        if (data.code === 1) {
          // 是点击购买按钮还是确认购买按钮
          if (isConfirm) {
            this.createOrder()
          } else {
            this.selectSubcourse()
          }
        } else if (data.code === 90302) {
          this.tipSameOrder(data.data.order_no)
        } else if (data.code === 90313) {
          this.$root.courseModalText = 'The course has already been bought! Click here to visit.'
          this.$root.courseModal = true
        } else {
          this.$toast({
            type: 'error',
            message: 'oops, something went wrong, please try again later'
          })
        }
      })
    },
    tipSameOrder (id) {
      this.$confirm({
        title: 'Order of the same course existed',
        message: 'There is an order of this exact course waiting for checkout. You can continue to pay the order other than create a new one.',
        cancelButton: true,
        confirmButtonText: 'Continue',
        handleAction: (val, res, rej) => {
          res()
          this.$router.push({
            name: 'payPage',
            params: {
              order_no: id
            }
          })
        }
      })
    },
    createOrder () {
      api.createOrder({
        data: {
          goods_id: this.bigCourseId + ''
        }
      }).then(res => {
        let data = res.data
        if (data.code === 1) {
          this.$router.push({
            name: 'payPage',
            params: {
              order_no: data.data.order_no
            }
          })
        } else if (data.code === 90302) {
          this.tipSameOrder(data.data.order_no)
        } else {
          this.$toast({
            type: 'error',
            message: 'Oops, something went wrong, please try again later'
          })
        }
      })
    },
    selectSubcourse () {
      if (this.mode === 'buying') return
      this.courseData.chapter.forEach((el, index) => {
        if (el.chapter_price === 0 || this.hasBuyChapters[el.chapter_id] === true) {
          el.chooseStatusClass = 'not-choosed'
        } else {
          this.realPrice += el.chapter_price
          el.chooseStatusClass = 'choosed'
        }
      })
      this.realPrice = Number((this.realPrice / 100).toFixed(2))
      this.changeTab({ tab: 'Syllabus' })
      if (document.querySelector('.ct-footer')) {
        document.querySelector('.ct-footer').style.display = 'none'
      }

      this.mode = 'buying'
    },
    addFreeCourse () {
      if (!this.isAuthenticated) {
        window.location.href = vueAppPassportDomin + '/login?return_url=' + window.location.href
        return
      }
      if (this.addFreeCouseLoading) return
      this.addFreeCouseLoading = true
      api.addFreeCourse({
        data: {
          class_id: this.bigCourseId + ''
        }
      }).then(res => {
        let data = res.data
        this.addFreeCouseLoading = false
        if (data.code === 1) {
          this.$root.courseModalText = 'This course was added to My Courses successfully! Click here to check.'
          this.$root.courseModal = true
        } else if (data.code === 90600) {
          this.$root.courseModalText = 'This course has already in My Courses page! Click here to visit.'
          this.$root.courseModal = true
        } else if (data.code === 90601) {
          this.$toast({
            type: 'warning',
            message: 'This course is not free.'
          })
        } else {
          this.$toast({
            type: 'error',
            message: 'Oops…Something went wrong, please try again later.'
          })
        }
      }, err => {
        this.$toast({
          type: 'error',
          message: 'Oops…Something went wrong, please try again later.'
        })
        console.log(err)
        this.addFreeCouseLoading = false
      })
    },
    cancel () {
      if (document.querySelector('.ct-footer')) {
        document.querySelector('.ct-footer').style.display = 'block'
      }
      this.mode = 'normal'
      this.courseData.chapter.forEach((el, index) => {
        el.chooseStatusClass = 'normal'
      })
      this.realPrice = 0
    },
    scrollEvent (e) {
      if (window.scrollY >= (8 + this.$refs['livecourse-detail-header'].scrollHeight - 38)) {
        this.isFixed = true
      } else {
        this.isFixed = false
      }
    },
    goLive (a, b) {
      this.$router.push({
        name: 'live-broadcast',
        params: {
          liveId: a,
          subId: b
        }
      })
    },
    goReplay (a, b) {
      this.$router.push({
        name: 'live-replay',
        params: {
          liveId: a,
          subId: b
        }
      })
    }
  },
  mounted () {
    if (isNaN(Number(this.bigCourseId))) {
      this.goNotFound()
      return
    }
    api.getLiveCourseDetail({
      params: {
        goods_id: this.bigCourseId
      }
    }).then(res => {
      let data = res.data
      if (data.code === 1) {
        this.courseData = this.formatData(res.data.data)
        if (!this.canView) {
          this.goNotFound()
          return
        }
        this.scrollEvent()
        document.addEventListener('scroll', this.scrollEvent)
      } else {
        this.goNotFound()
      }
    }, err => {
      this.goNotFound()
      console.log(err)
    })
    if (this.isAuthenticated) {
      api.queryChapters({
        params: {
          goods_id: this.bigCourseId
        }
      }).then(res => {
        let data = res.data
        if (data.code === 1) {
          data = data.data
          if (data && data.length > 0) {
            data.forEach(el => {
              this.hasBuyChapters[el.subclass_id] = true
            })
          }
        }
      })
    }
  },
  destroyed () {
    if (document.querySelector('.ct-footer')) {
      document.querySelector('.ct-footer').style.display = 'block'
    }
    document.removeEventListener('scroll', this.scrollEvent)
    this.$root.courseModal = false
  },
  computed: {
    ...mapGetters(['isAdminRole', 'isAuthenticated']),
    bigCourseId () {
      return this.$route.params.origin
    },
    canView () {
      return this.isAuthenticated ? (this.courseData.online || this.isAdminRole) : this.courseData.online
    },
    progress () {
      if (this.courseData.chapter) {
        let a = this.courseData.chapter.reduce((total, obj) => {
          return obj.chapter_live_broadcast_state >= 3 ? total + 1 : total
        }, 0)
        return {
          total: this.courseData.chapter.length,
          current: a
        }
      } else {
        return {
          total: 0,
          current: 0
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/_varaible.scss';
  @mixin overflowTextStyle($lines) {
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: $lines;
    line-clamp: $lines;
    -webkit-box-orient: vertical;
  }
  .livecourse-detail-container {
    padding: 8px 0 70px;
    color: #1a3d5e;
    .livecourse-detail-header {
      padding: 0 20px 38px;
      box-shadow:0px 2px 12px 0px rgba(211,222,232,0.37);
      border-radius:2px;
      margin-bottom: 8px;
      position: relative;
      .livecourse-detail-header-infobox {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 24px;
        .livecourse-detail-header-left {
          width: 505px;
          position: relative;
          .livecourse-detail-status-tip {
            position: absolute;
            top: 8px;
            left: -8px;
            padding: 6px;
            border-radius:2px;
            font-size:12px;
            font-weight:500;
            line-height:14px;
            &.notstart {
              background:rgba(254,249,238,1);
              color:rgba(250,203,88,1);
            }
            &.half {
              background:rgba(235,249,250,1);
              color:$primary;
            }
            &.total {
              background: #EFF4FA;
              color: #1A3D5E;
            }
          }
          img {
            width: 505px;
            height: 284px;
          }
        }
        .livecourse-detail-header-right {
          width: 571px;
            .join-status {
                background: rgba(55, 202, 215, 0.1);
                color: #37CAD7;
                padding: 5px 10px;
            }
          .livecourse-detail-title {
            font-size:20px;
            font-weight:500;
            color:rgba(26,61,94,1);
            line-height:26px;
            margin-bottom: 6px;
            @include overflowTextStyle(2)
          }
          .livecourse-detail-desp {
            font-size:14px;
            font-family:SFProText-Regular,SFProText;
            font-weight:400;
            color:rgba(54,85,114,1);
            line-height:22px;
            margin-bottom: 30px;
            @include overflowTextStyle(3)
          }
          .livecourse-detail-time {
            font-size:16px;
            font-weight:500;
            color:rgba(54,85,114,1);
            line-height:28px;
            position: relative;
            margin-bottom: 10px;
            display: flex;
            align-items: center;
            .livecourse-detail-time-tips {
              position: absolute;
              top: -14px;
              left: 0;
              height: 14px;
              font-size:14px;
              font-weight:800;
              color:rgba(26,61,94,.16);
              line-height:14px;
            }
            .livecourse-detail-time-spin {
              margin-left: 8px;
              padding: 8px;
              background:rgba(239,244,250,1);
              border-radius:14px;
              font-size:12px;
              font-weight:400;
              color:rgba(26,61,94,1);
              line-height:12px;
            }
          }
          .livecourse-detail-price {
            font-size:24px;
            font-weight:500;
            color:rgba(55,202,215,1);
            line-height:28px;
            margin-bottom: 16px;
            display: flex;
            align-items: center;
            .livecourse-detail-virtual-price {
              margin-left: 8px;
              font-size:16px;
              font-weight:500;
              color:rgba(163,177,191,1);
              text-decoration: line-through;
            }
          }
          .livecourse-detail-opration {
            height: 48px;
            .livecourse-detail-refund-tips {
              margin-left: 16px;
              font-size:12px;
              font-weight:400;
              color:rgba(163,177,191,1);
            }
          }
          .livecourse-detail-freetrial {
            position: relative;
            margin-top: 42px;
            .freetrial-tips {
              position: absolute;
              height: 14px;
              width: 100%;
              font-size:14px;
              font-weight:400;
              color:rgba(163,177,191,1);
              line-height:14px;
              top: -26px;
              display: flex;
              align-items: center;
              .line {
                flex: 1;
                height: 1px;
                background: #EFF4FA;
                margin-left: 10px;
              }
            }
            .freetrial-box {
              display: flex;
              justify-content: space-between;
              align-items: center;
              .freetrial-content {
                h3 {
                  font-size:14px;
                  font-weight:500;
                  color:rgba(54,85,114,1);
                  line-height:14px;
                  margin-bottom: 8px;
                }
                p {
                  font-size:14px;
                  font-weight:400;
                  color:rgba(163,177,191,1);
                  line-height:14px;
                }
              }
            }
          }
        }
        @media screen and (max-width: 1200px) {
          .livecourse-detail-header-left {
            width: 46%;
            img {
              width: 100%;
              height: unset;
            }
          }
          .livecourse-detail-header-right {
            width: 52%;
          }
        }
      }
      .livecourse-detail-header-navtab {
        position: absolute;
        bottom: 0px;
        left: 0;
        padding: 0 20px;
        width: 100%;
        background: #fff;
        z-index: 1;
        .livecourse-detail-header-navtab-list {
          display: flex;
          justify-content: flex-start;
          li {
            margin-right: 48px;
            >span {
              font-size:14px;
              font-weight:400;
              color:rgba(163,177,191,1);
              line-height: 38px;
              height: 38px;
              display: inline-block;
              position: relative;
              transition: all .3s;
              cursor: pointer;
              .underline {
                position: absolute;
                width: 0%;
                height: 1px;
                left: 0;
                bottom: 0;
                background: $primary;
                transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
              }
              &.active {
                color: $primary;
                .underline {
                  width: 100%;
                }
              }
              &:hover {
                .underline {
                  width: 100%;
                }
              }
            }
            &:last-child {
            //   display: none;
            }
          }
        }
        .fixbar-buy-box {
          float: right;
          display: flex;
          align-items: center;
          .price {
            font-size:20px;
            font-weight:500;
            color:rgba(55,202,215,1);
            margin-right: 12px;
          }
          .virtual-price {
            font-size:14px;
            font-weight:400;
            color:rgba(163,177,191,1);
            margin-right: 40px;
            text-decoration: line-through;
          }
        }
        &.fixed-bar {
          position: fixed;
          height: 48px;
          width: 100%;
          top: 76px;
          background: #fff;
          padding: 0;
          box-shadow: 0px 2px 12px 0px rgba(211, 222, 232, 0.37);
          .wrapper {
            padding: 0 0 0 20px;
            .livecourse-detail-header-navtab-list {
              li > span{
                line-height: 48px;
                height: 48px;
              }
            }
          }
        }
      }
    }
    .livecourse-detail-body {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      .livecourse-detail-tab-content {
        flex: 1;
        box-shadow:0px 2px 12px 0px rgba(211,222,232,0.37);
        border-radius:2px;
        overflow: hidden;
        .livecourse-detail-richtext-content {
          padding: 20px;
          word-break: break-word;
          & + div {
            min-height: 692px;
          }
        }
        .livecourse-detail-subcourse-box {
          > li {
            padding: 16px 48px;
            position: relative;
            .livecourse-detail-subcourse-head {
              height: 20px;
              line-height: 20px;
              margin-bottom: 20px;
              .livecourse-detail-subcourse-head-title {
                font-size:16px;
                font-weight:400;
                color:rgba(26,61,94,1);
                margin-right: 8px;
                line-height: 19px;
                float: left;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                max-width: 60%;
              }
              .livecourse-detail-subcourse-head-status {
                float: left;
                padding: 3px 6px;
                font-size:12px;
                font-weight:400;
                border-radius:2px;
                line-height: 14px;
                &.total {
                  background:rgba(247,251,255,1);
                  color:rgba(163,177,191,1);
                }
                &.half {
                  background:rgba(235,249,250,1);
                  color:rgba(55,202,215,1);
                }
                &.notstart {
                  background:rgba(250,203,88,0.1);
                  color:rgba(250,203,88,1);
                }
              }
              .livecourse-detail-subcourse-head-price {
                font-size:14px;
                font-weight:400;
                color:rgba(163,177,191,1);
                line-height:20px;
                float: right;
              }
            }
            .livecourse-detail-subcourse-body {
              font-size:14px;
              font-weight:400;
              color:rgba(163,177,191,1);
              display: flex;
              align-items: center;
              justify-content: flex-start;
            }
            .livecourse-detail-subcourse-tip {
              position: absolute;
              padding: 3px 16px 3px 11px;
              top: 15px;
              left: 0;
              border-radius: 0 11px 11px 0;
              background: #eff4fa;
              font-size: 14px;
              font-weight: 400;
              line-height: 1;
            }
            .join-class-btn {
              position: absolute;
              right: 48px;
              bottom: 16px;
            }
            &.not-choosed {
              background:rgba(250,250,250,0.84);
            }
            &.choosed {
              border-left: 1px solid #A3B1BF;
              border-right: 1px solid #A3B1BF;
              .livecourse-detail-subcourse-head {
                .livecourse-detail-subcourse-head-price {
                  color: #1A3D5E;
                }
              }
              .livecourse-detail-subcourse-tip {
                background: #1a3d5e;
                color: #fff;
              }
            }
            &.choosed:first-of-type {
              border-top: 1px solid #A3B1BF;
            }
            &.choosed:last-of-type {
              border-bottom: 1px solid #A3B1BF;
            }
            &.choosed + .not-choosed {
              border-top: 1px solid #A3B1BF;
            }
            &.not-choosed + .choosed {
              border-top: 1px solid #A3B1BF;
            }
            &.not-choosed + .not-choosed::before {
              content: '';
              display: block;
              position: absolute;
              left: 48px;
              right: 48px;
              top: 0;
              height:1px;
              border-top:1px solid rgba(241,246,252,1);
            }
            &.choosed + .choosed::before {
              content: '';
              display: block;
              position: absolute;
              left: 48px;
              right: 48px;
              top: 0;
              height:1px;
              border-top: 1px solid  #A3B1BF;
            }
            &.normal + .normal::before {
              content: '';
              display: block;
              position: absolute;
              left: 48px;
              right: 48px;
              top: 0;
              height:1px;
              border-top:1px solid  rgba(241,246,252,1);
            }
          }
        }
        .livecourse-detail-refund-content {
          padding: 26px 56px 85px;
          img {
            width: 100%;
          }
        }
        .livecourse-pad-Faqbox {
          padding: 26px 16px 60px;
          box-shadow:0px 2px 12px 0px rgba(211,222,232,0.37);
          border-radius:2px;
          >h2 {
            font-size:20px;
            font-weight:500;
            line-height:20px;
            margin-bottom: 30px;
            position: relative;
            .underline {
              position: absolute;
              width: 24px;
              height: 2px;
              background: $primary;
              left: 0;
              bottom: -6px;
            }
          }
          >div {
            margin-bottom: 32px;
            h4 {
              font-size:14px;
              font-weight:600;
              color:rgba(26,61,94,1);
              line-height:22px;
              margin-bottom: 8px;
              span {
                display: inline-block;
                padding: 3px;
                width: 18px;
                height: 18px;
                text-align: center;
                border-radius: 50%;
                background: $primary;
                margin-right: 8px;
                line-height: 1;
                font-size: 12px;
              }
            }
            p {
              font-size:14px;
              font-weight:400;
              color:rgba(54,85,114,1);
              line-height:20px;
            }
          }
        }
      }
      .livecourse-detail-faqbox {
        width: 292px;
        margin-left: 8px;
        padding: 26px 16px 60px;
        box-shadow:0px 2px 12px 0px rgba(211,222,232,0.37);
        border-radius:2px;
        >h2 {
          font-size:20px;
          font-weight:500;
          line-height:20px;
          margin-bottom: 30px;
          position: relative;
          .underline {
            position: absolute;
            width: 24px;
            height: 2px;
            background: $primary;
            left: 0;
            bottom: -6px;
          }
        }
        >div {
          margin-bottom: 32px;
          h4 {
            font-size:14px;
            font-weight:600;
            color:rgba(26,61,94,1);
            line-height:22px;
            margin-bottom: 8px;
            span {
              display: inline-block;
              padding: 3px;
              width: 18px;
              height: 18px;
              text-align: center;
              border-radius: 50%;
              background: $primary;
              margin-right: 8px;
              line-height: 1;
              font-size: 12px;
            }
          }
          p {
            font-size:14px;
            font-weight:400;
            color:rgba(54,85,114,1);
            line-height:20px;
          }
        }
      }
    }
    @media screen and (max-width: 992px) {
      .livecourse-detail-header {
        .livecourse-detail-header-navtab {
          .livecourse-detail-header-navtab-list {
            li {
              margin-right: 40px;
              >span {
                i {
                  display: none;
                }
              }
              &:last-child {
                display: block;
              }
            }
          }
          .fixbar-buy-box {
            .price {
              font-size: 16px;
              margin-right: 4px;
            }
            .virtual-price {
              margin-right: 8px;
            }
          }
          &.fixed-bar {
            .wrapper {
              .livecourse-detail-header-navtab-list {
                li {
                  margin-right: 24px;
                }
              }
            }
          }
        }
      }
      .livecourse-detail-body {
        .livecourse-detail-faqbox {
          display: none;
        }
      }
    }
    .livecourse-detail-comfirmbar {
      position: fixed;
      width: 100%;
      bottom: 0;
      left: 0;
      background: #1A3D5E;
      .confirm-box {
        padding: 8px 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .confirm-box-tips {
          font-size:14px;
          font-weight:400;
          color:rgba(163,177,191,1);
          line-height:22px;
          flex: 1;
          margin-right: 42px;
          .confirm-refund-time {
            color: #fff;
            font-size: 16px;
          }
        }
        .confirm-box-price {
          font-size:16px;
          line-height: 16px;
          font-weight:400;
          color:rgba(55,202,215,.63);
          height: 24px;
          display: flex;
          justify-content: space-between;
          align-items: baseline;
          margin-right: 32px;
          span {
            font-size:24px;
            font-weight:500;
            color:rgba(55,202,215,1);
            line-height: 24px;
            margin-left: 4px;
          }
        }
        .confirm-box-cancelbtn {
          color: rgba(118, 139, 158, 1);
        }
      }
    }
  }
  .livecourse-detail-container_mobile {
    .livecourse-detail-header-right {
        width: 100%!important;

    }
    .livecourse-detail-subcourse-body {
        display: flex;
        flex-direction: column;
        justify-content: flex-start!important;
        align-items: flex-start!important;
        >div {
            text-align: left;
            margin-bottom: 5px;
            svg {
                margin-left: 0!important;
            }
        }
    }
    .join-class-btn {
        width: 70px!important;
        min-width: unset!important;
        padding: 8px 8px!important;
        top: 16px!important;
        right: 16px!important;
    }
    .test-btn {
        // width: 76px!important;
        padding: 5px 5px!important;
        margin-bottom: 10px;
        // min-width: unset!important;
    }
  }
</style>
<style lang="scss">
  .livecourse-detail-richtext-content {
    img {
      width: 100%;
      vertical-align: middle;
    }
  }
</style>
